import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { CustomerBo } from '@utils/types/back-office/customer-bo.ts';

export const useUpdateCustomerBo = () => {
  const queryClient = useQueryClient();

  const updateCustomer = async ({
    customerId,
    data
  }: {
    customerId: string;
    data: CustomerBo;
  }) => {
    const response = await Axios.patch<CustomerBo>(
      `${PUT_URL(customerId).updateCustomerBo}`,
      data
    );
    return response.data;
  };

  return useMutation<
    CustomerBo,
    AxiosError<BaseError>,
    { customerId: string; data: CustomerBo }
  >(updateCustomer, {
    onSuccess: () => {
      queryClient.invalidateQueries('customer');
      queryClient.invalidateQueries('customersBo');
    },
    useErrorBoundary: false
  });
};
